// vv10 lp-sku-pricing-modifiers experiment (DEV-9783) — shared constants.
//
// Client-safe: this module must NOT import `next/server` (unlike
// `../middleware/lpSkuPriceVv10.ts`), so it can be pulled into client bundles —
// the V6 LP checkout price-injection gate (`@local/offer`) and the exposure
// tracking (`TrackingLoader`, `trackActions`, `checkoutExposure.ts` — the
// DEV-9883 pre-$pageview exposure shim) import from here to stay locked
// in step.

/** Cookie / query-override slot name for the vv10 experiment. */
export const VV10_COOKIE = "vv10"

/**
 * PostHog feature-flag key for the vv10 per-SKU price-premium experiment.
 * Deliberately human-readable and distinct from the cookie shorthand,
 * matching the house convention (vv6 → `store-apm`, etc.).
 */
export const VV10_FEATURE_FLAG = "lp-sku-pricing-modifiers"

/** Valid vv10 variants. Non-control is named `test` per team convention. */
export const VV10_VARIANTS = ["control", "test"] as const

export type Vv10Variant = (typeof VV10_VARIANTS)[number]

/** Type guard for anything read back from the cookie / query override. */
export const isVv10Variant = (value: unknown): value is Vv10Variant =>
  VV10_VARIANTS.includes(value as Vv10Variant)
